import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = { class: "register-form" }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { style: {"width":"50%"} }
const _hoisted_5 = { class: "btnCode" }

import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import type { FormInstance, FormRules } from "element-plus";
import { getCodeApi, registerApi } from "@/api/admin";
import { ElMessage } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'register',
  setup(__props) {

const router = useRouter();
const formInstance = ref<FormInstance>();

const form = reactive({
  username: "",
  password: "",
  phone: "",
  code: "",
});

const checkPhone = (rule: any, value: any, callback: any) => {
  if (!/^1[345789]\d{9}$/.test(value)) {
    console.log("手机号码格式不正确");
    return callback(new Error("手机号码格式不正确"));
  }
  return callback();
};

const rules = reactive<FormRules<typeof form>>({
  username: [
    { required: true, message: "请输入用户名", trigger: "blur" },
    {
      max: 10,
      min: 4,
      message: "用户名由4-10位数字或字母组成",
      trigger: "blur",
    },
  ],
  password: [
    { required: true, message: "请输入密码", trigger: "blur" },
    { max: 6, min: 6, message: "密码必须等于6位数", trigger: "blur" },
  ],
  phone: [
    { required: true, message: "请输入手机号码", trigger: "blur" },
    { validator: checkPhone, trigger: "blur" },
  ],
});

const SubmitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    console.log(valid);
    if (valid) {
      // 请求
      registerApi(form).then((res) => {
        console.log(res);
        if (res.success) {
          // 跳转
          router.push("/login");

          // 提示
          ElMessage({
            message: "注册成功，请登录",
            type: "success",
          });
        }
      });
    }
  });
};

const getCodeFun = () => {
  if (/^1[345789]\d{9}$/.test(form.phone)) {
    getCodeApi(form.phone);
  }
};

const toLogin = () => {
  router.push("/login");
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, "用户注册", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref_key: "formInstance",
          ref: formInstance,
          model: form,
          "label-width": "auto",
          "status-icon": "",
          style: {"max-width":"600px"},
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "username" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.username) = $event)),
                  placeholder: "输入用户名(4-10位数字或字母组成)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
                  "show-password": "",
                  placeholder: "输入登录密码(必须等于6位)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "phone" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.phone) = $event)),
                  placeholder: "请输入手机号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "code",
              rules: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_input, {
                    type: "text",
                    placeholder: "验证码",
                    modelValue: form.code,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.code) = $event))
                  }, null, 8, ["modelValue"]),
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "countdown" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: getCodeFun
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("获取验证码")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (SubmitForm(formInstance.value)))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("注册")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("取消")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createElementVNode("span", {
        class: "toLogin",
        onClick: toLogin
      }, "已有账号？立即登录 →")
    ])
  ]))
}
}

})